import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import StatusSemaphore from './StatusSemaphore';
import TrendArrow from './TrendArrow';
import { GoalsContext } from '../State/GoalsContext';
import '../utils/sharedStyles.css';

const TargetAssessment = ({ target }) => {
  const { goalType } = useContext(GoalsContext);
  const isUN = goalType === 'un';

  if (!target) return null;

  return (
    <div className="target-assessment-container">
      <div className="section-title section-title-spacing">
        <h6 className="sdg-section-title">Target Assessment</h6>
      </div>
      <Row>
        {/* Status (Semaphore) - Left Column - Hidden for UN indicators */}
        {!isUN && target?.computed?.target_semaphore_status && (
          <Col xs={12} md={6} className="target-assessment-col">
            <div className="assessment-box">
              <h6 className="assessment-box-title">
                Status
              </h6>
              <StatusSemaphore 
                category={target.computed.target_semaphore_status} 
                score={target.computed.target_status_score}
              />
            </div>
          </Col>
        )}

        {/* Progress (Arrow) - Right Column */}
        {target?.computed?.target_trend_status && (
          <Col xs={12} md={isUN ? 12 : 6} className="target-assessment-col">
            <div className="assessment-box">
              <h6 className="assessment-box-title">
                Progress
              </h6>
              <TrendArrow 
                category={target.computed.target_trend_status} 
                score={target.computed.target_trend_score}
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TargetAssessment;

